<i2a-page-content [hasPadding]="true" [headerStyle]="headerStyle">
    <ng-container navbar>
        <i2a-nav-bar [displayMenu]="false"></i2a-nav-bar>
    </ng-container>
    <ng-container content-body>
        <i2a-sub-title class="col-12" [title]='404'></i2a-sub-title>
        <router-outlet></router-outlet>
    </ng-container>
</i2a-page-content>